export const PRODUCT_SORT = {
  OUTSTANDING: 0,
  LATEST_PRODUCT: 1,
  SELLING_PRODUCT: 2,
  LOW_TO_HIGH_PRICE: 3,
  HIGH_TO_LOW_PRICE: 4,
  RELATED: 5,
  POPULAR: 6,
  DISCOUNT_PERCENTAGE: 7
}

export const getCategorySortOptions = (translate) => ([
  {
    text: 'popular',
    value: PRODUCT_SORT.POPULAR,
    label: translate('sort.popular')
  },
  {
    text: 'new',
    value: PRODUCT_SORT.LATEST_PRODUCT,
    label: translate('sort.new')
  },
  {
    text: 'hot_sale',
    value: PRODUCT_SORT.SELLING_PRODUCT,
    label: translate('sort.hot_sale')
  },
  {
    text: 'sort_desc',
    value: PRODUCT_SORT.LOW_TO_HIGH_PRICE,
    label: translate('sort.sort_desc')
  },
  {
    text: 'sort_asc',
    value: PRODUCT_SORT.HIGH_TO_LOW_PRICE,
    label: translate('sort.sort_asc')
  }
])
